import React from "react";
import styles from "./ProductDetails.module.scss";
import { parseCurrency } from "../../helpers/StringManipulation";

function ProductDetails({ product }) {
  const { images, price, isDonation } = product;
  const productPrice = isDonation
    ? "Donation"
    : "$" + parseCurrency(price) || "$0.00";

  const filteredUrl = images.filter((image) => image.url);

  return (
    <div className={styles.productDetail}>
      <div className={styles.images}>
        {filteredUrl.length && <img src={filteredUrl[0].url} className={styles.mainImage} />}
        <div className={styles.restImages}>
          {filteredUrl.length &&
          filteredUrl.map((image, index) => index !== 0 && <img src={image.url} />)}
        </div>
      </div>

      <div className={styles.details}>
        <h3>{product.name}</h3>
        <label>{productPrice}</label>
        <p>{product.description}</p>
      </div>
    </div>
  );
}

export default ProductDetails;
